SelfRegistrationResolver.$inject = [
  '$q',
  '$http',
  'CountryService'
];

export function SelfRegistrationResolver(
  $q,
  $http,
  CountryService
) {
  return function() {
    var countriesPromise = CountryService.getCountries(),
      // Load prefilled data
      registrationForm = $http.get(
        '/365FarmNet/mod/registration/rest/v1.0/public'
      );
    // Wait for all promises, but return an object with values
    return $q
      .all([countriesPromise, registrationForm])
      .then(function(promises) {
        return {
          sysCountries: CountryService.sortCountries(
            promises[0].data.filter(function(sysCountry) {
              // Only offer countries marked as "registerCountry" for registration
              return !!sysCountry.registerCountry;
            })
          ),
          regForm: promises[1].data
        };
      });
  };
}
